export const withLogic =
  (Component: React.ComponentType<any>): React.FC<any> =>
  ({ selectedIndex, internalIndex, ...rest }: any) => {
    const active =
      typeof selectedIndex === 'number' && internalIndex === selectedIndex;
    return (
      <Component
        {...{
          ...rest,
          active,
          onChange: (ev: React.MouseEvent<HTMLDivElement>) => {
            if (internalIndex) rest.onClick?.(ev, internalIndex);
          }
        }}
      />
    );
  };
